module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ecublens_VD-a2bf93807243750cedbc73e2c1af328a.svg";